/**
 * services/phone.js — phone number normalization.
 *
 * CRM returns 10-digit Indian numbers (9167452324).
 * Meta/webhook stores with country code (919167452324).
 * Always normalize to full format with country code in the store.
 */

export function normalizePhone(phone) {
  if (!phone) return '';
  const digits = String(phone).replace(/\D/g, '');
  if (digits.length === 10) return '91' + digits; // assume India
  return digits;
}
